import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      minWidth: '110px',
      marginLeft: '20px'
    }
  });

interface CommonOrderButtonsProps {
  classes: any;
  printPickupOrder: () => void;
};

const commonOrderButtons = (props: CommonOrderButtonsProps) => {

  return (
    <Button variant="contained" color="primary" onClick={ props.printPickupOrder } className={ props.classes.button }>Print</Button>
  );
}

export default withStyles(styles)(commonOrderButtons);